<nz-space class="mobile-report-control">
    <app-fa-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
      valueField="code">
    </app-fa-select>
    <span class="text-center">
      <span nz-icon nzType="swap-right" nzTheme="outline"></span>
    </span>
    <app-fa-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="code">
    </app-fa-select>
</nz-space>
  